
export const GET_ANALYZR_PACKAGE_REQUEST = 'GET_ANALYZR_PACKAGE_REQUEST';
export const GET_ANALYZR_PACKAGE_SUCCESS = 'GET_ANALYZR_PACKAGE_SUCCESS';
export const GET_ANALYZR_PACKAGE_ERROR   = 'GET_ANALYZR_PACKAGE_ERROR';

export const BUY_ANALYZR_PACKAGE_REQUEST = 'BUY_ANALYZR_PACKAGE_REQUEST';
export const BUY_ANALYZR_PACKAGE_SUCCESS = 'BUY_ANALYZR_PACKAGE_SUCCESS';
export const BUY_ANALYZR_PACKAGE_ERROR   = 'BUY_ANALYZR_PACKAGE_ERROR';
